import { HTMLProps } from 'react';
import UXButton from '@ux/button';
import '@ux/button/styles';

import { type ButtonProps } from './Button';

type Props = HTMLProps<HTMLAnchorElement> &
  ButtonProps & {
    dataEid: string;
  };

const Link = (props: Props): JSX.Element => {
  const { dataEid, ...combinedProps } = props;

  if (__DEV__ && props.href == null) {
    throw new Error('expected props to have a valid href, but it did not');
  }

  // use automatic logging rather than manual logging for links by using traffic's data-eid property.
  // this will handle adding a 75ms delay before redirecting the page to ensure the traffic request has finished.
  // https://godaddy-corp.atlassian.net/wiki/spaces/CKPT/pages/92310199/4.+Logging+Page+Clicks

  return <UXButton {...combinedProps} design='inline' data-eid={dataEid} />;
};

export default Link;
